import createExamModuleDoc from '../../api/examModules/createExamModuleDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export default function useCreateExamModule() {
  const {fn, loading, error} = useFunctionWrap(createExamModuleDoc);

  return {
    createExamModule: fn,
    loading,
    error,
  };
}
